// Styles for __name__ go here.
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

const { color, font } = baseVariables;

export const StyledHWSPrimaryDetachedNavigation = styled.div`
  background: ${color.alert10};
  border-top: ${toRem(1)} solid ${color.neutral20};
  border-bottom: ${toRem(1)} solid ${color.neutral20};
`;

export const StyledMainMenu = styled.ul`
  display: flex;
  align-items: center;
  gap: ${toRem(24)};
  padding-left: 0;
  list-style: none;
  flex-direction: row;
  margin-bottom: 0;

  .main-menu-item {
    display: block;
    cursor: pointer;
    color: ${color.neutral40};
    &:hover {
      color: ${color.base10};
    }
  }
`;

export const StyledMainMenuItem = styled.li`
  position: relative;
  align-self: stretch;
  height: ${toRem(48)};

  button,
  a {
    height: 100%;
    &:focus-visible {
      outline-offset: ${toRem(1)};
      outline: -webkit-focus-ring-color auto ${toRem(1)};
    }
  }
  &.active {
    .main-menu-item {
      color: ${color.base10};
      &::after {
        background-color: ${contextualVariable.linkNavBorderColor};
      }
    }
  }
  &:hover {
    .main-menu-item {
      color: ${color.base10};
    }
  }
  &.selected {
    .main-menu-item {
      color: ${color.base10};
    }

    .navigation-dropdown-container {
      position: absolute;
      left: ${toRem(-24)};

      .sub-menu {
        top: ${toRem(2)};
      }
    }
  }
  .main-menu-item {
    position: relative;
    font-size: ${font.fontS};
    font-weight: ${font.fontWeightMedium};
    line-height: ${toRem(14)};
    padding: ${toRem(16)} 0 ${toRem(16)};
    background-color: transparent;

    &::after {
      content: '';
      position: absolute;
      height: ${toRem(3)};
      width: 100%;
      bottom: 0;
      left: 0;
    }
    .icon-arrow {
      display: inline-block;
      height: ${toRem(16)};
      width: ${toRem(16)};
      &::before {
        font-size: ${toRem(8)};
      }
    }
  }
`;
